module.exports = __webpack_public_path__ + "static/media/hindi-flag.7cbe5cdf.svg";